import initMobileNav from './modules/mobile-nav';
import initMainNav from './modules/main-nav';
import initFadeIn from './modules/fade-in';
import initPostSlider from './modules/post-slider';
import initFeaturedDestinations from './modules/featured-destinations';
import initSearch from './modules/search';
import initTitleFit from './modules/title-fit';
import initLightboxDownload from './modules/lightbox-download';

initMobileNav();
initMainNav();
initFadeIn();
initPostSlider();
initFeaturedDestinations();
initSearch();
initTitleFit();
initLightboxDownload();
